import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
import UserApp from "./user";
import injectTapEventPlugin from "react-tap-event-plugin";
import firebase from "firebase";

import cardImg from "./user/card.svg";
import cardImg2 from "./user/residentcard.svg";

function uninstallSW() {
  try {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  } catch (err) {
    console.error(err);
  }
}

injectTapEventPlugin();

window.onerror = function(message, url, lineNumber) {
  const userAgent = navigator.userAgent;

  const data = {
    userAgent,
    message,
    url,
    lineNumber
  };

  try {
    firebase
      .database()
      .ref("/errors")
      .push(data);
  } catch (err) {
    alert(err);
  }
};

if (window.location.pathname.indexOf("/admin") === 0) {
  import(/*webpackChunkName: "admin"*/ "./admin/index").then(Admin => {
    const AdminApp = Admin.default;
    ReactDOM.render(<AdminApp />, document.getElementById("root"));
  });
} else if (window.location.pathname.indexOf("/resident") === 0) {
  // registerServiceWorker();
  uninstallSW();

  ReactDOM.render(
    <UserApp
      filter={deal => deal.allowResident}
      selector="Building"
      path="buildings"
      colors={["#4CB8C4", "#3CD3AD"]}
      card={cardImg2}
    />,
    document.getElementById("root")
  );
} else {
  // registerServiceWorker();
  uninstallSW();

  var color1 = "#c1531b";
  var color2 = "#a83279";

  ReactDOM.render(
    <UserApp
      filter={deal => deal.allowEmployee || deal.allowEmployee === undefined}
      selector="Company"
      path="companies"
      colors={[color1, color2]}
      card={cardImg}
    />,
    document.getElementById("root")
  );
}



// WEBPACK FOOTER //
// ./src/index.js